import React from 'react';
import { FROM_SAVED_QUERY } from '@/util/enums/EnumLayers';
import { SavedQuery } from '@/types';
import { SelectedSavedQueryLabel } from '@/features/startFromSavedQuery/SelectedSavedQueryLabel';
import ViewRef from '@/util/ViewRef';
import Layer from './Layer';

export default class LayerFromSavedQuery extends Layer {
  constructor(readonly _alias: string, readonly _parent: SavedQuery) {
    super(FROM_SAVED_QUERY);
  }

  alias = () => this._alias;

  ref = () => ViewRef.fromSavedQuery(this._parent);

  get parent() {
    return this._parent;
  }

  static createFromActionPayload = (alias: string, parent: SavedQuery) =>
    new LayerFromSavedQuery(alias, parent);

  editMode = () => (
    <SelectedSavedQueryLabel
      isInitiallyOpen
      name={this.parent.name}
      series={this.parent.series}
    />
  );

  readonlyMode = (onEditLayerClicked: F0) =>
    this.buildContent(onEditLayerClicked);

  buildContent = (editLayerClicked: F0) => (
    <SelectedSavedQueryLabel
      onClick={editLayerClicked}
      name={this.parent.name}
      series={this.parent.series}
    />
  );
}
